import editorEn from '../Editor/i18n.en';
import listEn from '../List/i18n.en';

const translations = {
  ...editorEn,
  ...listEn,
};

export default translations;
